import React from "react";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";

interface UserInfoProps {
  color?: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ color = "text.secondary" }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          textAlign: "center",
        }}
        className="user-info-view"
      >
        <Box
          sx={{
            textAlign: "center",
            width: "100%",
            "& .font-style": {
              // fontSize: 56,
              // color: "#0A8FDC",
              // fontWeight: "bold",
              // fontFamily: "Material Icons",
              // letterSpacing: "10px",
              // lineHeight: 0.5,
              backgroundColor: "#0A8FDC",
            },
          }}
        >
          {/* <text y="2" textAnchor="middle" className="font-style">
            AUTI
          </text> */}
          <Avatar
            variant="square"
            sx={{
              height: 78,
              width: "100%",
              "& .MuiAvatar-img": {
                objectFit: "fill",
                width: "80%",
                height: "66%",
              },
            }}
            className="font-style"
            src="/assets/images/logo.png"
          />
        </Box>
      </Box>
    </>
  );
};

export default UserInfo;
